module.exports = __webpack_public_path__ + "media/images/ww2500-bcca28c67d45013b2998e32883a7e8b3.svg";